var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 12.5,
    fill: "#EB5307"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0168 25.5508C14.4003 26.6881 13.9611 28.6403 14.9408 29.4869C16.0281 30.4266 17.9292 28.9348 18.735 27.7459C19.5919 26.4818 19.949 24.264 18.8868 23.5827C17.8246 22.9015 15.7675 24.1658 15.0168 25.5508Z",
    fill: "#FFFBEF",
    stroke: "#FFFBEF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5959 23.5723C18.7476 22.4369 24.8279 12.6603 29.1612 12.532C33.4945 12.4036 51.6498 33.0705 38.8204 37.1211C30.5945 39.7182 25.1218 28.114 25.1218 28.114C25.1218 28.114 17.5387 40.1201 10.1429 36.8953C-0.196102 31.2704 15.2304 11.7712 21.4035 12.521C25.8356 13.0593 31.0371 21.9833 31.2723 23.5577",
    stroke: "#FFFBEF",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1575 26.181C29.7023 25.2727 30.0815 24.1372 31.2197 23.6073C32.3317 23.0897 33.3715 23.728 33.9142 24.5341C33.9405 24.569 33.9518 24.5914 33.9518 24.5914C33.9395 24.5722 33.927 24.5531 33.9142 24.5341C33.773 24.347 33.1982 23.8021 31.5994 24.4401C29.7023 25.197 30.1575 26.181 30.1575 26.181Z",
    fill: "#FFFBEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9027 29.9657C31.9027 29.9657 30.3094 26.484 30.1575 26.181M30.1575 26.181C29.7023 25.2727 30.0815 24.1372 31.2197 23.6073C32.358 23.0775 33.4206 23.7588 33.9518 24.5914M30.1575 26.181C30.1575 26.181 29.7023 25.197 31.5994 24.4401M33.9518 24.5914C34.1794 24.8942 35.6969 28.3761 35.6969 28.3761M33.9518 24.5914C33.9518 24.5914 33.4965 23.6831 31.5994 24.4401M31.5994 24.4401L33.7239 29.1331",
    stroke: "#FFFBEF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.f2d506f7515372402d25614c2541a7f9.svg";
export { ForwardRef as ReactComponent };